// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 7/11/2023
 */

.PaymentStep_container__dVbHs{
    margin-top: 2rem;
}

.PaymentStep_paper__8K7xj {
    padding: 1.5rem 0;
    background: linear-gradient(91deg, rgba(90, 155, 216, 0.1) 23.22%, rgba(90, 155, 216, 0) 99.28%);
}

.PaymentStep_topic__tpKOA {
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 600;
    margin: 0 1.5rem 1.5rem 2.38rem;
}

.PaymentStep_inputContainer__tIznO {
    margin: 2.5rem 2.38rem;
}

.PaymentStep_subTitle__64b6j {
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
}

.PaymentStep_selectionContainer__MGfh\\+ {
    display: flex;
    margin-top: 1.75rem;
}

.PaymentStep_selectionContainer__MGfh\\+ :first-child {
    margin-left: 0;
}

.PaymentStep_option__JWxx4 {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 2.8rem;
    width: 10rem;
    border-radius: 0.5rem;
    border: 1px solid #5A9BD8;
    font-size: 1rem;
    font-weight: 400;
    margin: 0 2rem;
    background-color: #fff;
    text-align: center;
}

.PaymentStep_option__JWxx4:hover {
    cursor: pointer;
}

.PaymentStep_optionSelected__HWnz4 {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 2.8rem;
    width: 10rem;
    border-radius: 0.5rem;
    border: 1px solid #5A9BD8;
    font-size: 1rem;
    font-weight: 400;
    margin: 0 2rem;
    background-color: #5A9BD8;
    text-align: center;
}

.PaymentStep_paymentContainer__3cnbH {
    border-radius: 0.5rem;
    border: 1px solid #5A9BD8;
    background: linear-gradient(90deg, #FFF 1.24%, rgba(255, 255, 255, 0.00) 106.88%);
    padding: 1rem;
    margin: 2.5rem 2.38rem;
}

.PaymentStep_inputLabel__ywgmU {
    font-style: 1rem;
    font-weight: 400;
    margin-bottom: 1.5rem;
}

.PaymentStep_textInput__BwInE {
    margin-bottom: 1.5rem;
    border-radius: 0.5rem;
    border: 0.1px solid #5A9BD8;
    background: #FFF;
}

.PaymentStep_cardContainer__W6z0i {
    display: flex;
}

.PaymentStep_card__y2zpA {
    height: 2.3rem;
    width: 4rem;
    cursor: pointer;
    margin-right: 2rem;
    margin-bottom: 1.5rem;
}

.PaymentStep_button__R\\+x5\\+ {
    display: block;
    margin-left: 3rem;
    border-radius: 0.5rem;
    margin: 10px 0;
    height: 3rem;
    font-size: 1rem;
    font-weight: 500;
}

.PaymentStep_buttonProgress__16mvu {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  margin-left: -12px;
}

/* for mobile */
@media (max-width: 770px) {
    .PaymentStep_paper__8K7xj {
        background: #FFF;
    }
    .PaymentStep_topic__tpKOA {
        font-size: 1.5rem;
        font-weight: 600;
    }
    .PaymentStep_subTitle__64b6j {
        font-size: 1rem;
    }
    .PaymentStep_option__JWxx4, .PaymentStep_optionSelected__HWnz4 {
        margin: 0 0.25rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Checkout/PaymentStep.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gGAAgG;AACpG;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,iFAAiF;IACjF,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,eAAe;AACf;IACI;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 7/11/2023\r\n */\r\n\r\n.container{\r\n    margin-top: 2rem;\r\n}\r\n\r\n.paper {\r\n    padding: 1.5rem 0;\r\n    background: linear-gradient(91deg, rgba(90, 155, 216, 0.1) 23.22%, rgba(90, 155, 216, 0) 99.28%);\r\n}\r\n\r\n.topic {\r\n    font-size: 1.6rem;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    margin: 0 1.5rem 1.5rem 2.38rem;\r\n}\r\n\r\n.inputContainer {\r\n    margin: 2.5rem 2.38rem;\r\n}\r\n\r\n.subTitle {\r\n    font-size: 1rem;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n}\r\n\r\n.selectionContainer {\r\n    display: flex;\r\n    margin-top: 1.75rem;\r\n}\r\n\r\n.selectionContainer :first-child {\r\n    margin-left: 0;\r\n}\r\n\r\n.option {\r\n    display: inline-flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 2.8rem;\r\n    width: 10rem;\r\n    border-radius: 0.5rem;\r\n    border: 1px solid #5A9BD8;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    margin: 0 2rem;\r\n    background-color: #fff;\r\n    text-align: center;\r\n}\r\n\r\n.option:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n.optionSelected {\r\n    display: inline-flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 2.8rem;\r\n    width: 10rem;\r\n    border-radius: 0.5rem;\r\n    border: 1px solid #5A9BD8;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    margin: 0 2rem;\r\n    background-color: #5A9BD8;\r\n    text-align: center;\r\n}\r\n\r\n.paymentContainer {\r\n    border-radius: 0.5rem;\r\n    border: 1px solid #5A9BD8;\r\n    background: linear-gradient(90deg, #FFF 1.24%, rgba(255, 255, 255, 0.00) 106.88%);\r\n    padding: 1rem;\r\n    margin: 2.5rem 2.38rem;\r\n}\r\n\r\n.inputLabel {\r\n    font-style: 1rem;\r\n    font-weight: 400;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.textInput {\r\n    margin-bottom: 1.5rem;\r\n    border-radius: 0.5rem;\r\n    border: 0.1px solid #5A9BD8;\r\n    background: #FFF;\r\n}\r\n\r\n.cardContainer {\r\n    display: flex;\r\n}\r\n\r\n.card {\r\n    height: 2.3rem;\r\n    width: 4rem;\r\n    cursor: pointer;\r\n    margin-right: 2rem;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.button {\r\n    display: block;\r\n    margin-left: 3rem;\r\n    border-radius: 0.5rem;\r\n    margin: 10px 0;\r\n    height: 3rem;\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.buttonProgress {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  margin-top: -12px;\r\n  margin-left: -12px;\r\n}\r\n\r\n/* for mobile */\r\n@media (max-width: 770px) {\r\n    .paper {\r\n        background: #FFF;\r\n    }\r\n    .topic {\r\n        font-size: 1.5rem;\r\n        font-weight: 600;\r\n    }\r\n    .subTitle {\r\n        font-size: 1rem;\r\n    }\r\n    .option, .optionSelected {\r\n        margin: 0 0.25rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PaymentStep_container__dVbHs`,
	"paper": `PaymentStep_paper__8K7xj`,
	"topic": `PaymentStep_topic__tpKOA`,
	"inputContainer": `PaymentStep_inputContainer__tIznO`,
	"subTitle": `PaymentStep_subTitle__64b6j`,
	"selectionContainer": `PaymentStep_selectionContainer__MGfh+`,
	"option": `PaymentStep_option__JWxx4`,
	"optionSelected": `PaymentStep_optionSelected__HWnz4`,
	"paymentContainer": `PaymentStep_paymentContainer__3cnbH`,
	"inputLabel": `PaymentStep_inputLabel__ywgmU`,
	"textInput": `PaymentStep_textInput__BwInE`,
	"cardContainer": `PaymentStep_cardContainer__W6z0i`,
	"card": `PaymentStep_card__y2zpA`,
	"button": `PaymentStep_button__R+x5+`,
	"buttonProgress": `PaymentStep_buttonProgress__16mvu`
};
export default ___CSS_LOADER_EXPORT___;
